import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaUser, FaSignOutAlt, FaWhatsapp, FaBars, FaTimes, FaChevronDown, FaChevronUp, FaSearch, FaLock, FaTags, FaTools, FaBan, FaCar, FaCashRegister, FaClipboardList, FaSearchPlus, FaBoxes, FaSitemap, FaInfinity, FaChartLine, FaStore, FaChartPie, FaTruck, FaMoneyBillWave, FaFileInvoiceDollar, FaFileInvoice, FaCheckDouble, FaUsers, FaUserCog, FaPoll, FaLightbulb, FaCarBattery, FaCompactDisc, FaCogs, FaBoxOpen, FaFileUpload, FaMagic, FaShoppingBag, FaShoppingCart, FaComments, FaGavel, FaCamera, FaWarehouse, FaFileAlt, FaDatabase, FaInstagram, FaCog, FaShieldAlt, FaClipboardCheck, FaUndo } from 'react-icons/fa';
import { FaGraduationCap, FaBullhorn } from 'react-icons/fa';
import Cookies from 'js-cookie';
import axios from 'axios';
import { socket } from '../App';
import AutocompleteSearch from './AutocompleteSearch';
import LockScreen from './LockScreen';
import NotificationBell from './NotificationBell';
import { usePermissions } from '../context/PermissionsContext';

const PRODUCTOS_COLUMNS = [
    {
        title: 'Catálogo',
        description: 'Ficha, categorías y compatibilidades',
        items: [
            { name: 'Categorías', path: '/productos/categorias', permission: 'productos.categorias', Icon: FaTags, iconClass: 'text-yellow-500' },
            { name: 'Medidas empaque', path: '/productos/medidas-empaque', permission: 'productos.categorias', Icon: FaBoxOpen, iconClass: 'text-orange-400' },
            { name: 'Tornillería', path: '/productos/tornilleria', permission: 'productos.tornilleria', Icon: FaTools, iconClass: 'text-gray-400' },
            { name: 'Gestor Aplicaciones', path: '/productos/vehiculos/gestor', permission: 'productos.vehiculos', Icon: FaCar, iconClass: 'text-blue-400' },
            { name: 'Asistente Variantes', path: '/productos/crear-padre', permission: 'productos.padres', Icon: FaMagic, iconClass: 'text-amber-300' },
            { name: 'Variantes (Padres)', path: '/productos/padres', permission: 'productos.padres', Icon: FaSitemap, iconClass: 'text-teal-400' },
        ],
    },
    {
        title: 'Inventario',
        description: 'Operación de bodega del día a día',
        items: [
            { name: 'Agotados', path: '/productos', mobilePath: '/m/productos/', permission: 'productos.agotados', Icon: FaBan, iconClass: 'text-red-400' },
            { name: 'Vendidos Hoy', path: '/productos/revisar', mobilePath: '/m/productos/revisar', permission: 'productos.revisar', Icon: FaCashRegister, iconClass: 'text-green-400' },
            { name: 'Conteo', path: '/productos/conteo', mobilePath: '/m/productos/conteo', permission: 'productos.conteo', Icon: FaClipboardList, iconClass: 'text-purple-400' },
            { name: 'Auditoría', path: '/productos/auditoria', permission: 'productos.auditoria', Icon: FaSearchPlus, iconClass: 'text-orange-400' },
            { name: 'Gestión Inventarios', path: '/productos/gestor', permission: 'productos.gestor', Icon: FaBoxes, iconClass: 'text-amber-600' },
            { name: 'Infinito', path: '/productos/infinito', mobilePath: '/m/productos/infinito', permission: 'productos.infinito', Icon: FaInfinity, iconClass: 'text-indigo-400' },
        ],
    },
    {
        title: 'Rotación y control',
        description: 'Salud del surtido y productos apagados',
        items: [
            { name: 'Métricas', path: '/productos/metricas', mobilePath: '/m/productos/metricas', permission: 'productos.metricas', Icon: FaChartLine, iconClass: 'text-pink-400' },
            { name: 'Rotación inventario', path: '/productos/rotacion-inventario', permission: 'productos.metricas', Icon: FaChartPie, iconClass: 'text-amber-400' },
            { name: 'Auto-desactivados', path: '/productos/liquidacion-auto', permission: 'productos.liquidacion_auto', Icon: FaUndo, iconClass: 'text-rose-400', badgeKey: 'liquidacion_auto_pending' },
        ],
    },
];

const VENTA_ONLINE_COLUMNS = [
    {
        title: 'MercadoLibre',
        description: 'Pedidos, catálogo y postventa',
        items: [
            { name: 'Pedidos', path: '/meli?tab=pedidos', permission: 'meli.dashboard', Icon: FaShoppingBag, iconClass: 'text-yellow-400', badgeKey: 'meli_pending_invoice' },
            { name: 'Publicar Productos', path: '/meli/publicar', permission: 'meli.publicar', Icon: FaFileUpload, iconClass: 'text-blue-400' },
            { name: 'Productos Publicados', path: '/meli?tab=productos&subtab=publicados', permission: 'meli.dashboard', Icon: FaBoxOpen, iconClass: 'text-amber-400' },
            { name: 'Preguntas', path: '/meli/preguntas', permission: 'meli.preguntas', Icon: FaComments, iconClass: 'text-indigo-300', badgeKey: 'meli_questions' },
            { name: 'Reclamos', path: '/meli/reclamos', permission: 'meli.reclamos', Icon: FaGavel, iconClass: 'text-red-400', badgeKey: 'meli_claims' },
            { name: 'Calidad', path: '/meli?tab=calidad', permission: 'meli.dashboard', Icon: FaClipboardCheck, iconClass: 'text-sky-400' },
            { name: 'Compatibilidades', path: '/meli?tab=productos&subtab=compatibilidades', permission: 'meli.compatibilidades', Icon: FaSitemap, iconClass: 'text-teal-400' },
            { name: 'Posiciones', path: '/meli?tab=productos&subtab=posiciones', permission: 'meli.dashboard', Icon: FaTags, iconClass: 'text-pink-400' },
            { name: 'Dashboard', path: '/meli?tab=Dashboard', permission: 'meli.dashboard', Icon: FaChartLine, iconClass: 'text-emerald-400' },
        ],
    },
    {
        title: 'Tienda Virtual',
        description: 'Operación directa de OsoCommerce',
        headerPath: '/ecommerce',
        headerPermission: 'ecommerce.dashboard',
        items: [
            { name: 'Pedidos', path: '/ecommerce/orders', permission: 'ecommerce.orders', Icon: FaShoppingBag, iconClass: 'text-blue-400', badgeKey: 'ecommerce_orders' },
            { name: 'Reclamos', path: '/ecommerce/claims', permission: 'ecommerce.claims', Icon: FaGavel, iconClass: 'text-red-400', badgeKey: 'ecommerce_claims' },
            { name: 'Clientes', path: '/clientes/?tab=tienda', permission: 'ecommerce.clientes', Icon: FaUsers, iconClass: 'text-teal-400' },
            { name: 'Preguntas', path: '/ecommerce/questions', permission: 'ecommerce.questions', Icon: FaComments, iconClass: 'text-indigo-300', badgeKey: 'ecommerce_questions' },
            { name: 'Solicitudes Foto', path: '/ecommerce/photos', permission: 'ecommerce.photos', Icon: FaCamera, iconClass: 'text-emerald-400', badgeKey: 'photo_requests' },
            { name: 'Validación Bodega', path: '/ecommerce/leads/stock-check', permission: 'ecommerce.dashboard', Icon: FaWarehouse, iconClass: 'text-slate-300', badgeKey: 'stock_check' },
            { name: 'Reglas de Envío', path: '/ecommerce/shipping-rules', permission: 'ecommerce.shipping', Icon: FaTruck, iconClass: 'text-orange-400' },
            { name: 'Dashboard', path: '/ecommerce/dashboard/financial', permission: 'ecommerce.dashboard', Icon: FaChartLine, iconClass: 'text-violet-400' },
        ],
    },
    {
        title: 'Imotriz',
        description: 'Atención de pedidos y preguntas',
        headerPath: '/imotriz',
        headerPermission: 'imotriz.dashboard',
        items: [
            { name: 'Pedidos', path: '/imotriz/pedidos', permission: 'imotriz.orders', Icon: FaShoppingBag, iconClass: 'text-blue-400' },
            { name: 'Preguntas', path: '/imotriz/preguntas', permission: 'imotriz.questions', Icon: FaComments, iconClass: 'text-indigo-300' },
        ],
    },
];

const ADMINISTRACION_COLUMNS = [
    {
        title: 'Operación',
        description: 'Paneles administrativos del día a día',
        items: [
            { name: 'Dashboard', path: '/ventas/dashboard', permission: 'admin.dashboard', Icon: FaChartPie, iconClass: 'text-purple-400' },
            { name: 'Despachos', path: '/despachos/lista', permission: 'admin.despachos', Icon: FaTruck, iconClass: 'text-blue-400' },
            { name: 'Facturas', path: '/admin/facturas', permission: 'admin.facturas', Icon: FaFileInvoice, iconClass: 'text-indigo-300' },
            { name: 'Config general', path: '/administracion/config', permission: 'admin.config', Icon: FaCog, iconClass: 'text-yellow-400' },
            { name: 'Documentos', path: '/administracion/documentos', permission: 'ecommerce.cms', Icon: FaFileAlt, iconClass: 'text-red-400' },
            { name: 'Vault Backups', path: '/administracion/backups', permission: 'admin.backups', Icon: FaDatabase, iconClass: 'text-amber-400' },
            {
                name: 'Vault de claves',
                path: '/administracion/claves',
                permission: 'admin.claves',
                Icon: FaShieldAlt,
                iconClass: 'text-emerald-300',
                badge: 'Nuevo',
                buttonClass: 'bg-emerald-500/15 ring-1 ring-emerald-400/50 hover:bg-emerald-500/25 hover:text-emerald-200',
            },
            { name: 'Lotus Academy', path: '/capacitaciones', permission: 'capacitaciones.catalogo', Icon: FaGraduationCap, iconClass: 'text-yellow-400' },
        ],
    },
    {
        title: 'Pagos',
        description: 'Proveedores, recibos y links de pago',
        items: [
            { name: 'Órdenes de compra', path: '/compras/ordenes', permission: 'compras.ordenes', Icon: FaShoppingCart, iconClass: 'text-emerald-400' },
            { name: 'Facturas', path: '/admin/facturas', permission: 'admin.facturas', Icon: FaFileInvoice, iconClass: 'text-indigo-300' },
            { name: 'Pagos Proveedores', path: '/pagos/consolidados', permission: 'pagos.consolidados', Icon: FaFileInvoiceDollar, iconClass: 'text-green-400' },
            { name: 'Recibos y Vouchers', path: '/pagos/chequeo', permission: 'pagos.chequeo', Icon: FaCheckDouble, iconClass: 'text-cyan-300' },
            { name: 'Validar Ingreso FE', path: '/pagos/validar-dian', permission: 'pagos.validar_dian', Icon: FaFileUpload, iconClass: 'text-blue-300' },
            { name: 'Link Pago Clientes', path: '/pagos/clientes', permission: 'pagos.facturas_cliente', Icon: FaMoneyBillWave, iconClass: 'text-emerald-400' },
        ],
    },
    {
        title: 'Clientes',
        description: 'Gestión, encuestas y oportunidades',
        items: [
            { name: 'Gestor Clientes', path: '/clientes/', permission: 'clientes.gestor', Icon: FaUserCog, iconClass: 'text-orange-400' },
            { name: 'Encuestas', path: '/listadoencuestas', permission: 'clientes.encuestas', Icon: FaPoll, iconClass: 'text-indigo-300' },
            { name: 'Buscar Oportunidades', path: '/clientes/oportunidades/buscar', permission: 'clientes.oportunidades', Icon: FaLightbulb, iconClass: 'text-yellow-400' },
            { name: 'Baterías', path: '/clientes/oportunidades/baterias', permission: 'clientes.oportunidades', Icon: FaCarBattery, iconClass: 'text-green-400' },
            { name: 'Pastillas', path: '/clientes/oportunidades/pastillas', permission: 'clientes.oportunidades', Icon: FaCompactDisc, iconClass: 'text-slate-300' },
            { name: 'Correa Distribución', path: '/clientes/oportunidades/correadis', permission: 'clientes.oportunidades', Icon: FaCogs, iconClass: 'text-blue-300' },
            { name: 'Kits', path: '/clientes/oportunidades/kits', permission: 'clientes.oportunidades', Icon: FaBoxOpen, iconClass: 'text-amber-400' },
            { name: 'Reglas Recomendación', path: '/clientes/oportunidades/reglas', permission: 'clientes.oportunidades', Icon: FaMagic, iconClass: 'text-yellow-400' },
        ],
    },
    {
        title: 'Marketing',
        description: 'Audiencias, embudo y campañas cross-canal',
        headerPath: '/marketing',
        headerPermission: 'marketing.hub',
        items: [
            { name: 'Marketing Hub', path: '/marketing', permission: 'marketing.hub', Icon: FaBullhorn, iconClass: 'text-pink-500' },
            { name: 'Bandeja leads', path: '/marketing/leads', permission: 'marketing.hub', Icon: FaUsers, iconClass: 'text-orange-400' },
            { name: 'Social Meta', path: '/marketing/social', permission: 'marketing.hub', Icon: FaInstagram, iconClass: 'text-pink-400' },
            { name: 'Audiencias', path: '/marketing/audiencias', permission: 'marketing.audiencias', Icon: FaChartLine, iconClass: 'text-teal-400' },
            { name: 'Embudo', path: '/marketing/embudo', permission: 'marketing.hub', Icon: FaChartPie, iconClass: 'text-violet-400' },
            { name: 'Integraciones', path: '/marketing/integraciones', permission: 'marketing.integraciones', Icon: FaStore, iconClass: 'text-indigo-300' },
        ],
    },
];

const Navbar = ({ userRole }) => {
    const { hasPermission } = usePermissions();
    const navigate = useNavigate();
    const location = useLocation();
    const [activeDropdown, setActiveDropdown] = useState(null);
    const closeDropdownTimer = useRef(null);
    // const [userRole, setUserRole] = useState(null); // Ya no se gestiona internamente
    const [isLocked, setIsLocked] = useState(!!localStorage.getItem('appLocked'));

    // Mobile menu states
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [expandedMobileMenu, setExpandedMobileMenu] = useState(null);

    const employeeName = Cookies.get('nombre_empleado') || 'Usuario';
    const employeeId = Cookies.get('identificacion') || 'id';
    // const token = Cookies.get('token'); // Ya no es accesible

    /* 
    // ELIMINADO: Ya no podemos leer el token HttpOnly desde JS
    useEffect(() => {
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setUserRole(decoded.id_rol);
            } catch (error) {
                console.error('Error al decodificar el token:', error);
            }
        }
    }, [token]);
    */

    // Check lock state across tabs
    useEffect(() => {
        const handleStorageChange = (e) => {
            if (e.key === 'appLocked') {
                setIsLocked(!!e.newValue);
                // Optional: If unlocked from another tab, reload to sync user state?
                // if (!e.newValue) window.location.reload(); 
            }
        };

        window.addEventListener('storage', handleStorageChange);
        return () => window.removeEventListener('storage', handleStorageChange);
    }, []);

    useEffect(() => {
        return () => {
            if (closeDropdownTimer.current) {
                clearTimeout(closeDropdownTimer.current);
            }
        };
    }, []);

    // Close mobile menu when route changes
    useEffect(() => {
        setMobileMenuOpen(false);
    }, [location.pathname]);

    // --- WhatsApp unread chat count (API-driven) ---
    const [unreadChatCount, setUnreadChatCount] = useState(0);
    const [navBadges, setNavBadges] = useState({});

    const fetchUnreadCount = async () => {
        try {
            const res = await axios.get('/api/osobot/chats/unread-count');
            setUnreadChatCount(res.data.count || 0);
        } catch (err) {
            console.error('Error fetching unread chat count:', err);
        }
    };

    const fetchNavBadges = async () => {
        try {
            const res = await axios.get('/api/global/nav-badges');
            setNavBadges(res.data?.badges || {});
        } catch (err) {
            console.error('Error fetching nav badges:', err);
        }
    };

    const formatBadgeCount = (n) => {
        const num = Number(n) || 0;
        if (num <= 0) return null;
        return num > 99 ? '99+' : String(num);
    };

    const NavCountPill = ({ badgeKey, className = '' }) => {
        const label = formatBadgeCount(navBadges[badgeKey]);
        if (!label) return null;
        return (
            <span
                className={`shrink-0 min-w-[1.25rem] h-5 px-1 bg-red-500 text-white text-[10px] font-bold rounded-full inline-flex items-center justify-center ${className}`}
            >
                {label}
            </span>
        );
    };

    useEffect(() => {
        fetchUnreadCount();
        fetchNavBadges();

        // Actualizar en tiempo real cuando cambia el estado de lectura
        const handleReadStatusUpdate = () => fetchUnreadCount();
        socket.on('chat_read_status_updated', handleReadStatusUpdate);

        const handleNavBadgesRefresh = () => fetchNavBadges();
        window.addEventListener('nav-badges-refresh', handleNavBadgesRefresh);

        const badgeInterval = setInterval(fetchNavBadges, 150000); // ~2.5 min

        return () => {
            socket.off('chat_read_status_updated', handleReadStatusUpdate);
            window.removeEventListener('nav-badges-refresh', handleNavBadgesRefresh);
            clearInterval(badgeInterval);
        };
    }, []);

    // Re-fetch al navegar fuera del chat
    useEffect(() => {
        fetchUnreadCount();
    }, [location.pathname]);

    useEffect(() => {
        if (activeDropdown === 'ventaonline' || activeDropdown === 'productos' || mobileMenuOpen) {
            fetchNavBadges();
        }
    }, [activeDropdown, mobileMenuOpen]);


    const handleLogout = () => {
        localStorage.removeItem('appLocked');
        navigate('/logout');
    };

    const handleLock = () => {
        localStorage.setItem('appLocked', 'true');
        setIsLocked(true);
    };

    const handleUnlock = () => {
        // Cookies are already updated by LockScreen
        localStorage.removeItem('appLocked');
        setIsLocked(false);
        // Force reload to ensure all components get fresh data if user changed
        window.location.reload();
    };

    const isActive = (path) => location.pathname.startsWith(path);

    const openDropdown = (menu) => {
        if (closeDropdownTimer.current) {
            clearTimeout(closeDropdownTimer.current);
        }
        setActiveDropdown(menu);
    };

    const closeDropdownWithDelay = () => {
        if (closeDropdownTimer.current) {
            clearTimeout(closeDropdownTimer.current);
        }
        closeDropdownTimer.current = setTimeout(() => {
            setActiveDropdown(null);
        }, 180);
    };

    const navigateFromDropdown = (path) => {
        navigate(path);
        setActiveDropdown(null);
    };

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    const toggleMobileSubMenu = (menu) => {
        setExpandedMobileMenu(expandedMobileMenu === menu ? null : menu);
    };

    // Mobile Menu Items Structure
    const mobileMenuItems = [
        {
            name: 'Productos',
            subItems: PRODUCTOS_COLUMNS.flatMap((column) =>
                column.items.map(({ name, path, mobilePath, permission, badgeKey }) => ({
                    name,
                    path: mobilePath || path,
                    permission,
                    badgeKey,
                }))
            ),
        },
        {
            name: 'Venta Online',
            subItems: [
                { name: 'MercadoLibre', path: '/meli', permission: 'meli.dashboard' },
                { name: 'Pedidos ML', path: '/m/meli/pedidos', permission: 'meli.dashboard', badgeKey: 'meli_pending_invoice' },
                { name: 'Preguntas ML', path: '/m/meli/preguntas', permission: 'meli.preguntas', badgeKey: 'meli_questions' },
                { name: 'Publicar ML', path: '/m/meli/publicar', permission: 'meli.publicar' },
                { name: 'Reclamos ML', path: '/meli/reclamos', permission: 'meli.reclamos', badgeKey: 'meli_claims' },
                { name: 'Calidad ML', path: '/meli?tab=calidad', permission: 'meli.dashboard' },
                { name: 'Compatibilidades ML', path: '/meli/compatibilidades', permission: 'meli.compatibilidades' },
                { name: 'Promociones ML', path: '/meli?tab=Precios', permission: 'meli.promotions' },
                { name: 'Tienda', path: '/ecommerce', permission: 'ecommerce.dashboard' },
                { name: 'Pedidos Tienda', path: '/ecommerce/orders', permission: 'ecommerce.orders', badgeKey: 'ecommerce_orders' },
                { name: 'Reclamos Tienda', path: '/ecommerce/claims', permission: 'ecommerce.claims', badgeKey: 'ecommerce_claims' },
                { name: 'Preguntas Tienda', path: '/ecommerce/questions', permission: 'ecommerce.questions', badgeKey: 'ecommerce_questions' },
                { name: 'Solicitudes Foto', path: '/ecommerce/photos', permission: 'ecommerce.photos', badgeKey: 'photo_requests' },
                { name: 'Validación Bodega', path: '/ecommerce/leads/stock-check', permission: 'ecommerce.dashboard', badgeKey: 'stock_check' },
                { name: 'Pedidos Imotriz', path: '/imotriz/pedidos', permission: 'imotriz.orders' },
                { name: 'Preguntas Imotriz', path: '/imotriz/preguntas', permission: 'imotriz.questions' },
            ],
        },
        {
            name: 'Pagos',
            subItems: [
                { name: 'Órdenes de compra', path: '/compras/ordenes', permission: 'compras.ordenes' },
                { name: 'Facturas', path: '/admin/facturas', permission: 'admin.facturas' },
                { name: 'Pagos Proveedores', path: '/pagos/consolidados', permission: 'pagos.consolidados' },
                { name: 'Recibos y Vouchers', path: '/pagos/chequeo', permission: 'pagos.chequeo' },
                { name: 'Validar Ingreso FE', path: '/pagos/validar-dian', permission: 'pagos.validar_dian' },
                { name: 'Link Pago Clientes', path: '/pagos/clientes', permission: 'pagos.facturas_cliente' },
            ],
        },
        {
            name: 'Clientes',
            subItems: [
                { name: 'Gestor Clientes', path: '/clientes/', permission: 'clientes.gestor' },
                { name: 'Encuestas', path: '/m/encuestas/metricas', permission: 'clientes.encuestas' },
                { name: 'Buscar Oportunidades', path: '/clientes/oportunidades/buscar', permission: 'clientes.oportunidades' },
                { name: 'Baterías', path: '/clientes/oportunidades/baterias', permission: 'clientes.oportunidades' },
                { name: 'Pastillas', path: '/clientes/oportunidades/pastillas', permission: 'clientes.oportunidades' },
                { name: 'Correa Distribución', path: '/clientes/oportunidades/correadis', permission: 'clientes.oportunidades' },
                { name: 'Kits', path: '/clientes/oportunidades/kits', permission: 'clientes.oportunidades' },
                { name: 'Reglas de Recomendación', path: '/clientes/oportunidades/reglas', permission: 'clientes.oportunidades' },
            ]
        },
        {
            name: 'Administración',
            subItems: [
                { name: 'Dashboard', path: '/ventas/dashboard', permission: 'admin.dashboard' },
                { name: 'Despachos', path: '/m/despachos', permission: 'admin.despachos' },
                { name: 'Facturas', path: '/admin/facturas', permission: 'admin.facturas' },
                { name: 'Config general', path: '/administracion/config', permission: 'admin.config' },
                { name: 'Documentos', path: '/administracion/documentos', permission: 'ecommerce.cms' },
                { name: 'Vault Backups', path: '/administracion/backups', permission: 'admin.backups' },
                { name: 'Vault de claves', path: '/administracion/claves', permission: 'admin.claves', badge: 'Nuevo' },
                { name: 'Marketing Hub', path: '/marketing', permission: 'marketing.hub' },
                { name: 'Audiencias', path: '/marketing/audiencias', permission: 'marketing.audiencias' },
            ]
        },
        {
            name: 'Lotus Academy',
            subItems: [
                { name: 'Catálogo', path: '/capacitaciones', permission: 'capacitaciones.catalogo' },
                { name: 'Gestión (Admin)', path: '/capacitaciones/gestion', permission: 'admin.capacitaciones_gestion' },
            ]
        },
    ];

    const filteredMobileMenuItems = mobileMenuItems.map(item => {
        if (item.subItems) {
            const allowedSubs = item.subItems.filter(sub => hasPermission(sub.permission));
            if (allowedSubs.length > 0) return { ...item, subItems: allowedSubs };
            return null;
        }
        return hasPermission(item.permission) ? item : null;
    }).filter(Boolean);

    const productosColumns = PRODUCTOS_COLUMNS.map((column) => ({
        ...column,
        items: column.items.filter((item) => hasPermission(item.permission)),
    })).filter((column) => column.items.length > 0);
    const showProductos = productosColumns.length > 0;
    const ventaOnlineColumns = VENTA_ONLINE_COLUMNS.map((column) => ({
        ...column,
        items: column.items.filter((item) => hasPermission(item.permission)),
    })).filter((column) => column.items.length > 0);
    const showVentaOnline = ventaOnlineColumns.length > 0;
    const administracionColumns = ADMINISTRACION_COLUMNS.map((column) => ({
        ...column,
        items: column.items.filter((item) => hasPermission(item.permission)),
    })).filter((column) => column.items.length > 0);
    const showAdministracion = administracionColumns.length > 0;



    return (
        <header className="relative z-50">
            <LockScreen isOpen={isLocked} onUnlock={handleUnlock} />

            {/* --- DESKTOP NAVBAR --- */}
            <nav className="hidden md:flex sticky top-0 bg-gradient-to-r from-official-from via-official-via to-official-to z-50 transition-all duration-300 shadow-lg text-white border-b-4 border-yellow-500">
                <div className="flex items-center gap-2 p-2">
                    <img
                        src="/images/logos.png"
                        width="180"
                        alt="Logo"
                        className="brightness-0 invert cursor-pointer"
                        onClick={() => navigate('/dashboard/welcome')}
                    />
                </div>

                <div className="flex flex-1 items-center justify-end">
                    {/* Autocomplete Search - Wrapper with light text for input if needed, handled by component */}
                    <div className="flex-1 max-w-xl mx-4 text-gray-800">
                        <AutocompleteSearch />
                    </div>

                    {/* Search Icon Link */}
                    <div
                        className="group cursor-pointer mx-2 p-2 rounded-full hover:bg-white/10 transition-all ease-in-out"
                        onClick={() => navigate('/productos/buscar')}
                        title="Buscador Avanzado"
                    >
                        <FaSearch className="text-white text-xl group-hover:text-yellow-300 transition-colors" />
                    </div>

                    {/* Tornillo Icon */}
                    <div
                        className="group cursor-pointer mx-2 transition-colors ease-in-out"
                        onClick={() => navigate('/productos/tornilleria/cotizador')}
                        title="Cotizador Tornillería"
                    >
                        <svg
                            width="28px"
                            height="28px"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="fill-white group-hover:fill-yellow-300 transition-colors ease-in-out"
                        >
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M12.6173 1.07615C12.991 0.921369 13.4211 1.00692 13.7071 1.29292L22.7071 10.2929C22.9931 10.5789 23.0787 11.009 22.9239 11.3827C22.7691 11.7564 22.4045 12 22 12H17.4142L7 22.4142C6.62493 22.7893 6.11622 23 5.58579 23H3C1.89543 23 1 22.1046 1 21V18.4142C1 17.8838 1.21071 17.3751 1.58579 17C5.05723 13.5286 8.52858 10.0572 12 6.58582V2.00003C12 1.59557 12.2436 1.23093 12.6173 1.07615ZM10.5 10.9142L9.41422 12L12 14.5858L13.0858 13.5L10.5 10.9142ZM14.5 12.0858L11.9142 9.49999L13 8.41424L15.5858 11L14.5 12.0858ZM10.5858 16L8 13.4142L6.91422 14.5L9.5 17.0858L10.5858 16ZM8.08579 18.5L5.50001 15.9142L4.41422 17L7 19.5858L8.08579 18.5ZM5.58579 21L3 18.4142V21H5.58579ZM14 4.41424V6.58582L17.4142 10H19.5858L14 4.41424Z"
                            />
                        </svg>
                    </div>

                    {/* Notification Bell */}
                    <NotificationBell />

                    {/* Chat */}
                    <div
                        className="relative flex h-full items-center p-3 cursor-pointer text-white hover:text-yellow-300 transition-colors ease-in-out"
                        onClick={() => navigate('/osobot/chat')}
                    >
                        <FaWhatsapp className='text-3xl' />
                        {/* Badge de notificaciones */}
                        {unreadChatCount > 0 && (
                            <div
                                className="absolute top-1 right-1 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center border-2 border-indigo-600 shadow-md"
                            >
                                {unreadChatCount}
                            </div>
                        )}
                    </div>

                    {/* Products Dropdown */}
                    {showProductos && (
                        <div
                            className={`relative flex h-full items-center px-4 cursor-pointer font-bold ${isActive('/productos') ? 'text-yellow-300' : 'text-white hover:text-yellow-300'
                                } transition-colors ease-in-out`}
                            onMouseEnter={() => openDropdown('productos')}
                            onMouseLeave={closeDropdownWithDelay}
                        >
                            <span className="relative inline-flex items-center gap-1.5">
                                Productos
                                {(() => {
                                    const label = formatBadgeCount(navBadges.liquidacion_auto_pending);
                                    if (!label) return null;
                                    return (
                                        <span className="min-w-[1.15rem] h-[1.15rem] px-1 bg-red-500 text-white text-[9px] font-bold rounded-full inline-flex items-center justify-center">
                                            {label}
                                        </span>
                                    );
                                })()}
                            </span>
                            {activeDropdown === 'productos' && (
                                <div className="absolute top-full right-0 bg-gray-900/95 backdrop-blur-md text-gray-100 shadow-2xl rounded-b-2xl text-left z-50 w-[820px] max-w-[calc(100vw-2rem)] border-t-4 border-yellow-500 animate-fade-in-down border-x border-b border-gray-700 p-4">
                                    <div className="grid grid-cols-3 gap-3">
                                        {productosColumns.map((column) => (
                                            <div key={column.title} className="rounded-xl border border-gray-700 bg-white/[0.03] overflow-hidden">
                                                <div className="px-4 py-3 border-b border-gray-700 bg-white/[0.04]">
                                                    <div className="flex items-center gap-2">
                                                        {column.title === 'Catálogo' && <FaTags className="text-yellow-500" />}
                                                        {column.title === 'Inventario' && <FaBoxes className="text-amber-500" />}
                                                        {column.title === 'Rotación y control' && <FaChartPie className="text-amber-400" />}
                                                        <h3 className="font-bold text-white">{column.title}</h3>
                                                    </div>
                                                    <p className="mt-1 text-xs font-normal text-gray-400">{column.description}</p>
                                                </div>
                                                <div className="py-2">
                                                    {column.items.map((item) => {
                                                        const Icon = item.Icon;
                                                        return (
                                                            <button
                                                                key={`${column.title}-${item.path}-${item.name}`}
                                                                type="button"
                                                                className="w-full px-4 py-2.5 hover:bg-white/10 hover:text-yellow-400 cursor-pointer transition-all flex items-center gap-3 text-sm text-left"
                                                                onClick={() => navigateFromDropdown(item.path)}
                                                            >
                                                                <Icon className={`shrink-0 ${item.iconClass}`} />
                                                                <span className="flex-1">{item.name}</span>
                                                                {item.badgeKey && <NavCountPill badgeKey={item.badgeKey} />}
                                                            </button>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Venta Online Dropdown */}
                    {showVentaOnline && (
                        <div
                            className={`relative flex h-full items-center px-4 cursor-pointer font-bold ${isActive('/meli') || isActive('/ecommerce') || isActive('/imotriz') ? 'text-yellow-300' : 'text-white hover:text-yellow-300'
                                } transition-colors ease-in-out`}
                            onMouseEnter={() => openDropdown('ventaonline')}
                            onMouseLeave={closeDropdownWithDelay}
                        >
                            <span className="relative inline-flex items-center gap-1.5">
                                Venta Online
                                {(() => {
                                    const total =
                                        (Number(navBadges.meli_pending_invoice) || 0) +
                                        (Number(navBadges.meli_questions) || 0) +
                                        (Number(navBadges.meli_claims) || 0) +
                                        (Number(navBadges.ecommerce_orders) || 0) +
                                        (Number(navBadges.ecommerce_claims) || 0) +
                                        (Number(navBadges.ecommerce_questions) || 0) +
                                        (Number(navBadges.photo_requests) || 0) +
                                        (Number(navBadges.stock_check) || 0);
                                    const label = formatBadgeCount(total);
                                    if (!label) return null;
                                    return (
                                        <span className="min-w-[1.15rem] h-[1.15rem] px-1 bg-red-500 text-white text-[9px] font-bold rounded-full inline-flex items-center justify-center">
                                            {label}
                                        </span>
                                    );
                                })()}
                            </span>
                            {activeDropdown === 'ventaonline' && (
                                <div className="absolute top-full right-0 bg-gray-900/95 backdrop-blur-md text-gray-100 shadow-2xl rounded-b-2xl text-left z-50 w-[820px] max-w-[calc(100vw-2rem)] border-t-4 border-yellow-500 animate-fade-in-down border-x border-b border-gray-700 p-4">
                                    <div className="grid grid-cols-3 gap-3">
                                        {ventaOnlineColumns.map((column) => (
                                            <div key={column.title} className="rounded-xl border border-gray-700 bg-white/[0.03] overflow-hidden">
                                                {column.headerPath && (!column.headerPermission || hasPermission(column.headerPermission)) ? (
                                                    <button
                                                        type="button"
                                                        className="w-full px-4 py-3 border-b border-gray-700 bg-white/[0.04] text-left hover:bg-white/10 transition-colors"
                                                        onClick={() => navigateFromDropdown(column.headerPath)}
                                                    >
                                                        <div className="flex items-center gap-2">
                                                            {column.title === 'Tienda Virtual' && <FaStore className="text-yellow-400" />}
                                                            {column.title === 'Imotriz' && <FaCar className="text-blue-400" />}
                                                            <h3 className="font-bold text-white">{column.title}</h3>
                                                        </div>
                                                        <p className="mt-1 text-xs font-normal text-gray-400">{column.description}</p>
                                                    </button>
                                                ) : (
                                                    <div className="px-4 py-3 border-b border-gray-700 bg-white/[0.04]">
                                                        <div className="flex items-center gap-2">
                                                            {column.title === 'MercadoLibre' ? (
                                                                <img src="/images/meli-logo-white.svg" alt="MercadoLibre" className="h-6 max-w-[130px]" />
                                                            ) : (
                                                                <>
                                                                    {column.title === 'Tienda Virtual' && <FaStore className="text-yellow-400" />}
                                                                    {column.title === 'Imotriz' && <FaCar className="text-blue-400" />}
                                                                    <h3 className="font-bold text-white">{column.title}</h3>
                                                                </>
                                                            )}
                                                        </div>
                                                        <p className="mt-1 text-xs font-normal text-gray-400">{column.description}</p>
                                                    </div>
                                                )}
                                                <div className="py-2">
                                                    {column.items.map((item) => {
                                                        const Icon = item.Icon;
                                                        return (
                                                            <button
                                                                key={`${column.title}-${item.path}-${item.name}`}
                                                                type="button"
                                                                className="w-full px-4 py-2.5 hover:bg-white/10 hover:text-yellow-400 cursor-pointer transition-all flex items-center gap-3 text-sm text-left"
                                                                onClick={() => navigateFromDropdown(item.path)}
                                                            >
                                                                <Icon className={`shrink-0 ${item.iconClass}`} />
                                                                <span className="flex-1">{item.name}</span>
                                                                {item.badgeKey && <NavCountPill badgeKey={item.badgeKey} />}
                                                            </button>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Administración Dropdown */}
                    {showAdministracion && (
                        <div
                            className={`relative flex h-full items-center px-4 cursor-pointer font-bold ${isActive('/pagos') || isActive('/clientes') || isActive('/ventas/dashboard') || isActive('/despachos') || isActive('/marketing') || isActive('/admin/facturas') ? 'text-yellow-300' : 'text-white hover:text-yellow-300'
                                } transition-colors ease-in-out`}
                            onMouseEnter={() => openDropdown('administracion')}
                            onMouseLeave={closeDropdownWithDelay}
                        >
                            <span>Administración</span>
                            {activeDropdown === 'administracion' && (
                                <div className="absolute top-full right-0 bg-gray-900/95 backdrop-blur-md text-gray-100 shadow-2xl rounded-b-2xl text-left z-50 w-[1080px] max-w-[calc(100vw-2rem)] border-t-4 border-yellow-500 animate-fade-in-down border-x border-b border-gray-700 p-4">
                                    <div className="grid grid-cols-4 gap-3">
                                        {administracionColumns.map((column) => (
                                            <div key={column.title} className="rounded-xl border border-gray-700 bg-white/[0.03] overflow-hidden">
                                                {column.headerPath && (!column.headerPermission || hasPermission(column.headerPermission)) ? (
                                                    <button
                                                        type="button"
                                                        className="w-full px-4 py-3 border-b border-gray-700 bg-white/[0.04] text-left hover:bg-white/10 transition-colors"
                                                        onClick={() => navigateFromDropdown(column.headerPath)}
                                                    >
                                                        <div className="flex items-center gap-2">
                                                            {column.title === 'Marketing' && <FaBullhorn className="text-pink-500" />}
                                                            <h3 className="font-bold text-white">{column.title}</h3>
                                                        </div>
                                                        <p className="mt-1 text-xs font-normal text-gray-400">{column.description}</p>
                                                    </button>
                                                ) : (
                                                <div className="px-4 py-3 border-b border-gray-700 bg-white/[0.04]">
                                                    <div className="flex items-center gap-2">
                                                        {column.title === 'Operación' && <FaChartPie className="text-purple-400" />}
                                                        {column.title === 'Pagos' && <FaMoneyBillWave className="text-green-400" />}
                                                        {column.title === 'Clientes' && <FaUsers className="text-orange-400" />}
                                                        {column.title === 'Marketing' && <FaBullhorn className="text-pink-500" />}
                                                        <h3 className="font-bold text-white">{column.title}</h3>
                                                    </div>
                                                    <p className="mt-1 text-xs font-normal text-gray-400">{column.description}</p>
                                                </div>
                                                )}
                                                <div className="py-2">
                                                    {column.items.map((item) => {
                                                        const Icon = item.Icon;
                                                        return (
                                                            <button
                                                                key={`${column.title}-${item.path}-${item.name}`}
                                                                type="button"
                                                                className={`w-full px-4 py-2.5 hover:bg-white/10 hover:text-yellow-400 cursor-pointer transition-all flex items-center gap-3 text-sm text-left ${item.buttonClass || ''}`}
                                                                onClick={() => navigateFromDropdown(item.path)}
                                                            >
                                                                <Icon className={`shrink-0 ${item.iconClass}`} />
                                                                <span className="flex-1">{item.name}</span>
                                                                {item.badge && (
                                                                    <span className="shrink-0 text-[10px] font-bold uppercase tracking-wide bg-emerald-400 text-emerald-950 px-1.5 py-0.5 rounded">
                                                                        {item.badge}
                                                                    </span>
                                                                )}
                                                            </button>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Lock Button (Icono Candado) */}
                    <div
                        className='relative flex items-center justify-center p-2 mx-3 cursor-pointer font-bold bg-rose-500 hover:bg-rose-600 border border-rose-400 rounded-lg text-white transition-all shadow-md hover:shadow-lg transform hover:scale-105'
                        onClick={handleLock}
                        title="Bloquear sesión"
                    >
                        <FaLock className="text-sm" />
                    </div>

                    {/* User Dropdown */}
                    <div
                        className='relative flex h-full items-center px-4 cursor-pointer font-bold bg-white/10 hover:bg-white/20 transition-colors'
                        onMouseEnter={() => openDropdown('user')}
                        onMouseLeave={closeDropdownWithDelay}
                    >
                        <div className="flex items-center gap-2">
                            <div className="bg-white/20 p-2 rounded-full">
                                <FaUser className="text-white text-lg" />
                            </div>
                            <span className="text-sm font-medium hidden lg:block">{employeeName.split(' ')[0]}</span>
                        </div>
                        {activeDropdown === 'user' && (
                            <div className="absolute top-full right-0 bg-gray-900/95 backdrop-blur-md text-gray-100 shadow-2xl text-center z-50 w-[250px] rounded-b-xl border-t-4 border-yellow-500 border-x border-b border-gray-700">
                                <div className="font-bold my-4 px-2">
                                    {employeeName}
                                    <br />
                                    <span className='text-sm font-normal text-gray-500'>CC. {employeeId}</span>
                                </div>
                                {hasPermission('admin.usuarios') && (
                                    <div className="p-3 hover:bg-white/10 hover:text-yellow-400 cursor-pointer transition-colors" onClick={() => navigate('/usuarios')}>
                                        Usuarios
                                    </div>
                                )}
                                {hasPermission('admin.sesiones') && (
                                    <div className="p-3 hover:bg-white/10 hover:text-yellow-400 cursor-pointer transition-colors border-t border-gray-700" onClick={() => navigate('/usuarios/sesiones')}>
                                        Sesiones
                                    </div>
                                )}
                                {hasPermission('admin.auditor') && (
                                    <div className="p-3 hover:bg-white/10 hover:text-yellow-400 cursor-pointer transition-colors border-t border-gray-700" onClick={() => navigate('/auditor')}>
                                        Auditor
                                    </div>
                                )}
                                {hasPermission('admin.capacitaciones_gestion') && (
                                    <div className="p-3 hover:bg-yellow-500/20 hover:text-yellow-500 cursor-pointer transition-colors border-t border-gray-700 font-bold" onClick={() => navigate('/capacitaciones/gestion')}>
                                        Gestión Lotus Academy
                                    </div>
                                )}
                                {hasPermission('admin.notificaciones') && (
                                    <div className="p-3 hover:bg-white/10 hover:text-yellow-400 cursor-pointer transition-colors border-t border-gray-700" onClick={() => navigate('/notificaciones/configuracion')}>
                                        Centro de Notificaciones
                                    </div>
                                )}
                                {hasPermission('admin.cron_jobs') && (
                                    <div className="p-3 hover:bg-white/10 hover:text-yellow-400 cursor-pointer transition-colors border-t border-gray-700" onClick={() => navigate('/admin/cron-jobs')}>
                                        Cron Jobs Dinámicos
                                    </div>
                                )}
                                {hasPermission('admin.ops') && (
                                    <div className="p-3 hover:bg-rose-500/20 hover:text-rose-300 cursor-pointer transition-colors border-t border-gray-700" onClick={() => navigate('/admin/ops')}>
                                        Tablero Ops
                                    </div>
                                )}
                                {hasPermission('admin.backups') && (
                                    <div className="p-3 hover:bg-white/10 hover:text-yellow-400 cursor-pointer transition-colors border-t border-gray-700" onClick={() => navigate('/administracion/backups')}>
                                        Vault Backups S3
                                    </div>
                                )}
                                {hasPermission('admin.claves') && (
                                    <div className="p-3 hover:bg-emerald-500/20 hover:text-emerald-300 cursor-pointer transition-colors border-t border-gray-700 flex items-center justify-center gap-2 bg-emerald-500/10" onClick={() => navigate('/administracion/claves')}>
                                        <FaShieldAlt className="text-emerald-300" />
                                        <span>Vault de claves</span>
                                        <span className="text-[10px] font-bold uppercase tracking-wide bg-emerald-400 text-emerald-950 px-1.5 py-0.5 rounded">Nuevo</span>
                                    </div>
                                )}
                                {/* Lotus Points */}
                                {hasPermission('lotus.billetera') && (
                                    <div className="p-3 hover:bg-yellow-500/20 hover:text-yellow-400 cursor-pointer transition-colors border-t border-gray-700 flex items-center gap-2" onClick={() => navigate('/lotus/mi-billetera')}>
                                        <span>🪷</span> Mi Billetera Lotus
                                    </div>
                                )}
                                {hasPermission('lotus.admin') && (
                                    <div className="p-3 hover:bg-yellow-500/20 hover:text-yellow-400 cursor-pointer transition-colors border-t border-gray-700 flex items-center gap-2 font-bold" onClick={() => navigate('/admin/lotus')}>
                                        <span>🪷</span> Centro de Comando Lotus
                                    </div>
                                )}
                                <div className="p-3 hover:bg-white/10 hover:text-yellow-400 cursor-pointer transition-colors border-t border-gray-700" onClick={() => navigate('/change-password')}>
                                    Cambiar Contraseña
                                </div>
                                <div className="p-3 hover:bg-red-500/20 text-red-400 hover:text-red-300 cursor-pointer flex items-center justify-center gap-2 transition-colors border-t border-gray-700" onClick={handleLogout}>
                                    <span>Cerrar Sesión</span>
                                    <FaSignOutAlt className="text-lg" />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </nav>

            {/* --- MOBILE NAVBAR --- */}
            <nav className="md:hidden sticky top-0 bg-[#181818] bg-opacity-95 backdrop-blur-md text-white flex items-center justify-between p-4 z-50 shadow-lg h-16">
                {/* Search Mobile Icon */}
                <button
                    onClick={() => navigate('/productos/buscar')}
                    className="p-2 text-gray-300 hover:text-white transition-colors"
                >
                    <FaSearch className="text-xl" />
                </button>


                {/* Logo */}
                <div className="flex-grow flex justify-center">
                    <img
                        onClick={() => navigate('/dashboard/welcome')}
                        src="/images/animated-logo-osorio-repuestos.webp"
                        alt="Logo Osorio"
                        className="h-10 cursor-pointer"
                    />
                </div>

                {/* Hamburger Menu */}
                <div className="flex items-center gap-2">
                    {/* Notification Bell Mobile */}
                    <div className="p-1">
                        <NotificationBell />
                    </div>
                    <button
                        onClick={() => navigate('/osobot/chat')}
                        className="relative text-gray-300 hover:text-white transition-colors focus:outline-none p-2"
                    >
                        <FaWhatsapp className="w-6 h-6" />
                        {unreadChatCount > 0 && (
                            <div className="absolute top-0 right-0 bg-red-500 text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center">
                                {unreadChatCount}
                            </div>
                        )}
                    </button>
                    <button onClick={toggleMobileMenu} className="text-gray-300 hover:text-white transition-colors focus:outline-none p-2">
                        <FaBars className="w-6 h-6" />
                    </button>
                </div>
            </nav>

            {/* --- MOBILE SEARCH BAR (Sticky below header) --- */}
            <div className="md:hidden sticky top-16 z-40 bg-[#181818] p-2 border-b border-gray-800 shadow-md">
                <AutocompleteSearch isMobile={true} />
            </div>

            {/* --- MOBILE MENU DRAWER --- */}
            <div
                className={`fixed inset-0 bg-gray-950 text-white flex flex-col z-[60] transition-transform duration-300 ease-in-out transform ${mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'
                    } md:hidden`}
            >
                {/* Header with Close Button */}
                <div className="w-full flex justify-end p-4 border-b border-gray-800">
                    <button onClick={toggleMobileMenu} className="text-gray-400 hover:text-white transition-colors focus:outline-none p-2">
                        <FaTimes className="w-8 h-8" />
                    </button>
                </div>

                {/* Menu Items */}
                <div className="flex-1 overflow-y-auto py-4">
                    {/* User Info Mobile */}
                    <div className="px-6 mb-6 text-center border-b border-gray-800 pb-4">
                        <div className="flex justify-center mb-2">
                            <div className="bg-blue-600 p-3 rounded-full">
                                <FaUser className="text-white text-2xl" />
                            </div>
                        </div>
                        <h3 className="text-xl font-bold">{employeeName}</h3>
                        <p className="text-gray-400 text-sm">CC. {employeeId}</p>
                    </div>

                    {/* Mobile Lock Button */}
                    <button
                        onClick={handleLock}
                        className="w-full flex items-center justify-center gap-2 py-4 mb-4 text-yellow-500 font-bold hover:bg-yellow-500/10 transition-colors border-b border-gray-800"
                    >
                        <FaLock />
                        <span>Bloquear / Cambiar Usuario</span>
                    </button>

                    {filteredMobileMenuItems.map((item, index) => (
                        <div key={index} className="w-full border-b border-gray-800/50 last:border-0">
                            {item.subItems ? (
                                <div className="w-full">
                                    <button
                                        onClick={() => toggleMobileSubMenu(item.name)}
                                        className="flex items-center justify-between w-full text-lg font-semibold py-4 px-6 text-gray-300 hover:text-white hover:bg-gray-900 transition-colors"
                                    >
                                        <span>{item.name}</span>
                                        {expandedMobileMenu === item.name ? <FaChevronUp /> : <FaChevronDown />}
                                    </button>
                                    <div
                                        className={`bg-gray-900 overflow-hidden transition-all duration-300 ${expandedMobileMenu === item.name ? 'max-h-[600px] opacity-100 py-2' : 'max-h-0 opacity-0'
                                            }`}
                                    >
                                        {item.subItems.map((subItem, subIndex) => (
                                            <button
                                                key={subIndex}
                                                onClick={() => {
                                                    navigate(subItem.path);
                                                    setMobileMenuOpen(false);
                                                }}
                                                className={`flex items-center gap-2 w-full text-left py-3 px-10 text-gray-400 hover:text-yellow-400 hover:pl-12 transition-all duration-200 ${
                                                    subItem.badge ? 'text-emerald-300' : ''
                                                }`}
                                            >
                                                <span className="flex-1">{subItem.name}</span>
                                                {subItem.badgeKey && <NavCountPill badgeKey={subItem.badgeKey} />}
                                                {subItem.badge && (
                                                    <span className="text-[10px] font-bold uppercase tracking-wide bg-emerald-400 text-emerald-950 px-1.5 py-0.5 rounded">
                                                        {subItem.badge}
                                                    </span>
                                                )}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            ) : (
                                <button
                                    onClick={() => {
                                        navigate(item.path);
                                        setMobileMenuOpen(false);
                                    }}
                                    className="block w-full text-left text-lg font-semibold py-4 px-6 text-gray-300 hover:text-white hover:bg-gray-900 transition-colors"
                                >
                                    {item.name}
                                </button>
                            )}
                        </div>
                    ))}

                    {/* Admin Users Link Mobile */}
                    {hasPermission('admin.usuarios') && (
                        <button
                            onClick={() => {
                                navigate('/usuarios');
                                setMobileMenuOpen(false);
                            }}
                            className="block w-full text-left text-lg font-semibold py-4 px-6 text-blue-400 hover:text-blue-300 hover:bg-gray-900 transition-colors border-t border-gray-800"
                        >
                            Usuarios
                        </button>
                    )}
                    {hasPermission('admin.sesiones') && (
                        <button
                            onClick={() => {
                                navigate('/usuarios/sesiones');
                                setMobileMenuOpen(false);
                            }}
                            className="block w-full text-left text-lg font-semibold py-4 px-6 text-blue-400 hover:text-blue-300 hover:bg-gray-900 transition-colors"
                        >
                            Sesiones
                        </button>
                    )}
                    {hasPermission('admin.auditor') && (
                        <button
                            onClick={() => {
                                navigate('/auditor');
                                setMobileMenuOpen(false);
                            }}
                            className="block w-full text-left text-lg font-semibold py-4 px-6 text-blue-400 hover:text-blue-300 hover:bg-gray-900 transition-colors"
                        >
                            Auditor
                        </button>
                    )}
                    {hasPermission('admin.ops') && (
                        <button
                            onClick={() => {
                                navigate('/admin/ops');
                                setMobileMenuOpen(false);
                            }}
                            className="block w-full text-left text-lg font-semibold py-4 px-6 text-rose-400 hover:text-rose-300 hover:bg-gray-900 transition-colors"
                        >
                            Tablero Ops
                        </button>
                    )}

                    {/* Lotus Points Mobile */}
                    {hasPermission('lotus.billetera') && (
                        <button
                            onClick={() => { navigate('/lotus/mi-billetera'); setMobileMenuOpen(false); }}
                            className="block w-full text-left text-lg font-semibold py-4 px-6 text-yellow-400 hover:text-yellow-300 hover:bg-gray-900 transition-colors border-t border-gray-800 flex items-center gap-2"
                        >
                            🪷 Mi Billetera Lotus
                        </button>
                    )}
                    {hasPermission('lotus.admin') && (
                        <button
                            onClick={() => { navigate('/admin/lotus'); setMobileMenuOpen(false); }}
                            className="block w-full text-left text-lg font-semibold py-4 px-6 text-yellow-400 hover:text-yellow-300 hover:bg-gray-900 transition-colors border-t border-gray-800 flex items-center gap-2"
                        >
                            🪷 Centro de Comando Lotus
                        </button>
                    )}

                    <button
                        onClick={() => {
                            navigate('/change-password');
                            setMobileMenuOpen(false);
                        }}
                        className="block w-full text-left text-lg font-semibold py-4 px-6 text-gray-300 hover:text-white hover:bg-gray-900 transition-colors border-t border-gray-800"
                    >
                        Cambiar Contraseña
                    </button>

                    {/* Logout Mobile */}
                    <button
                        onClick={handleLogout}
                        className="w-full flex items-center justify-center gap-2 py-6 text-red-500 font-bold hover:bg-red-500/10 transition-colors mt-4"
                    >
                        <span>Cerrar Sesión</span>
                        <FaSignOutAlt />
                    </button>
                </div>
            </div>
        </header>
    );
};

export default Navbar;
